import image from '@/assets/images/manufacturers/iox-lab.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'IOX_LAB',
  label: 'IOX-Lab',
  image,
}));
